import { css } from 'styled-components';

const AccountOverviewNewStyle = css`
  &.account-dashboard-container {
    background: ${(props) => props.theme.colorPalette.gray[3400]};
  }
  .account-tile-item {
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      padding-left: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
      width: calc(100% - ${(props) => props.theme.spacing.ELEM_SPACING.MED});
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      padding-left: ${(props) => props.theme.spacing.ELEM_SPACING.XL};
      width: calc(100% - ${(props) => props.theme.spacing.ELEM_SPACING.XL});
    }
  }
  .account-tile-item:not(:first-child) {
    margin-top: ${(props) => props.theme.spacing.LAYOUT_SPACING.SM};
  }
`;

export default AccountOverviewNewStyle;
